// Brand-green folder glyph with a per-type badge (Images/Documents/Important/Archive),
// detected from the folder name (works with the emoji-prefixed default folders).
function detectType(name = '') {
  if (name.includes('🖼') || /\bimages?\b/i.test(name)) return 'images';
  if (name.includes('📄') || /\bdocuments?\b/i.test(name)) return 'documents';
  if (name.includes('⭐') || /\bimportant\b/i.test(name)) return 'important';
  if (name.includes('📦') || /\barchive\b/i.test(name)) return 'archive';
  return 'plain';
}

export default function FolderIcon({ name = '', size = 40 }) {
  const type = detectType(name);
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" style={{ filter: 'drop-shadow(0 1px 3px rgba(0,0,0,.3))' }}>
      <path d="M2.5 7.2a2 2 0 0 1 2-2h4a1 1 0 0 1 .72.3L11 7.2h8.5a2 2 0 0 1 2 2v.6H2.5z" fill="#1f9c56"/>
      <path d="M2.5 9.2h19v8a2 2 0 0 1-2 2H4.5a2 2 0 0 1-2-2z" fill="#2ed573"/>
      {type === 'images' && (
        <g stroke="#06120a" strokeWidth="1.4" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="9.4" cy="13.2" r="1.1"/>
          <path d="M6.5 17l2.5-2.3 2 1.8 2.2-2.2 3.3 2.7"/>
        </g>
      )}
      {type === 'documents' && (
        <g stroke="#06120a" strokeWidth="1.4" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 12.2h4.2l1.8 1.8v4.4H9z"/>
          <path d="M13.2 12.2v1.8H15"/>
        </g>
      )}
      {type === 'important' && (
        <path d="M12 11.4l1.15 2.35 2.55.3-1.85 1.8.45 2.55L12 17.15 9.65 18.4l.45-2.55-1.85-1.8 2.55-.3z" fill="#ffcd50"/>
      )}
      {type === 'archive' && (
        <g stroke="#06120a" strokeWidth="1.4" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path d="M7 13l5-2 5 2-5 2z"/>
          <path d="M7 13v3.4l5 2 5-2V13"/>
        </g>
      )}
    </svg>
  );
}
